<div class="flex flex-col w-full ">
    <mat-toolbar color="primary" class="flex flex-col sm:flex-row
        content-center"
        *ngIf="!loggedIn">
        <div class="toolbar-logo"
            [routerLink]="['/']"><img matRipple style="max-height:100%"
                class="!cursor-pointer"
                src="assets/img/logo.png" alt="LG&E" class="logo"></div>
        <div class="toolbar-title
            justify-start">
            <p>LG&E
                and KU Energy LLC
                Contributions</p>
        </div>
    </mat-toolbar>
    <!-- <mat-toolbar color="primary" fxLayout="column" *ngIf="!loggedIn"
        fxShow="false" fxShow.lt-sm="true">
        <div style="height:100%;"><img style="max-height:100%;"
                src="assets/img/logo.png" alt="LG&E" class="logo"></div>
    </mat-toolbar>
    <mat-toolbar color="primary" fxLayout="column" *ngIf="!loggedIn"
        fxShow="false" fxShow.lt-sm="true">
        <div fxLayoutAlign="center center" fxLayout.lt-md="start center">
            <span style="color:#eeeeee"><b>LG&E
                    and KU Energy LLC
                    Contributions</b></span></div>
    </mat-toolbar> -->
    <mat-toolbar color="primary" class="flex flex-row flex-wrap w-full"
        *ngIf="loggedIn">
        <button class="w-16" mat-icon-button *ngIf="mobileQuery.matches"
            (click)="openSidenav()">
            <mat-icon>menu</mat-icon>
        </button>
        <div class="toolbar-logo" [routerLink]="['/']"
            *ngIf="!mobileQuery.matches"><img matRipple
                style="max-height:100%"
                src="assets/img/logo.png" alt="LG&E" class="logo"></div>
        <div class="toolbar-title
            justify-start">
            <p>{{screenName}}</p>
        </div>
        <div *ngIf="user != null && !mobileQuery.matches"
            [routerLink]="isInternal() ? []: ['/profile']" class="account-box
            justify-center
            items-center
            content-center">
            <mat-icon mat-list-icon style="width: 32px; vertical-align:
                middle;">account_circle</mat-icon>
            <span>{{user.fullName}}</span>
        </div>
    </mat-toolbar>
    <mat-sidenav-container (backdropClick)="closeSidenav()" autosize
        [class.sidenav-container-mobile]="mobileQuery.matches">

        <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches"
            [opened]="keepMenuOpen(mobileQuery.matches)"
            (keydown.escape)="closeSidenav()"
            [disableClose]="!mobileQuery.matches" *ngIf="loggedIn"
            class="sm:!p-5">
            <mat-nav-list>
                <!-- <mat-list-item matHeader disabled>Navigate</mat-list-item> -->
                <mat-list-item role="listitem" mat-list-item routerLink="/home"
                    (click)="closeSidenav()" routerLinkActive="active-route"
                    [routerLinkActiveOptions]={exact:true}>
                    <mat-icon mat-list-icon>home</mat-icon>
                    <h4 mat-line>Home</h4>
                </mat-list-item>

                <mat-list-item role="listitem" *ngIf="isInternal() ||
                    !isProfileExpired" mat-list-item routerLink="/charity-forms"
                    (click)="closeSidenav()" routerLinkActive="active-route">
                    <mat-icon mat-list-icon>assignment</mat-icon>
                    <h4 mat-line>Grant Applications</h4>
                </mat-list-item>

                <mat-list-item role="listitem" *ngIf="hasRole(isAdmin)"
                    mat-list-item routerLink="/admin" (click)="closeSidenav()"
                    [routerLinkActive]="['active-route']">
                    <mat-icon mat-list-icon>supervisor_account</mat-icon>
                    <h4 mat-line>Admin</h4>
                </mat-list-item>

                <!-- <mat-list-item role="listitem" *ngIf="!hasRole(isAdmin) &&(hasRole('PFTPAPPROVER') || hasRole ('CITAPPROVER') || hasRole('FOUNDATIONAPPROVER'))"
                    mat-list-item routerLink="/form-approver" (click)="closeSidenav()" [routerLinkActive] = "['active-route']">
                    <mat-icon color="primary" mat-list-icon>supervisor_account</mat-icon>
                    <h4 mat-line>Form Admin</h4>
                </mat-list-item> -->
                <!-- <mat-list-item role="listitem" *ngIf="hasRole(isApprover)" mat-list-item routerLink="/approver" (click)="closeSidenav()" [routerLinkActive] = "['active-route']">
                  <mat-icon color="primary" mat-list-icon>account_box</mat-icon>
                  <h4 mat-line>Approver</h4>
              </mat-list-item>

              <mat-list-item role="listitem" *ngIf="hasRole(isReviewer)" mat-list-item routerLink="/reviewer" (click)="closeSidenav()" [routerLinkActive] = "['active-route']">
                  <mat-icon color="primary" mat-list-icon>account_circle</mat-icon>
                  <h4 mat-line>Reviewer</h4>
              </mat-list-item> -->
                <!-- <h3 matSubheader>Account</h3> -->
                <mat-list-item role="listitem" *ngIf="!isInternal() &&
                    !isProfileExpired" mat-list-item routerLink="/profile"
                    (click)="closeSidenav()" routerLinkActive="active-route"
                    [routerLinkActiveOptions]={exact:true}>
                    <mat-icon mat-list-icon>account_circle
                    </mat-icon>
                    <h4 mat-line>My Account</h4>
                </mat-list-item>

                <mat-list-item role="listitem" *ngIf="!isInternal() &&
                    isProfileExpired" mat-list-item routerLink="/profile"
                    (click)="closeSidenav()" routerLinkActive="active-route"
                    [routerLinkActiveOptions]={exact:true}>
                    <mat-icon color="warn" mat-list-icon>account_circle
                    </mat-icon>
                    <h4 mat-line style="color:red">My Account</h4>
                    <mat-icon color="warn">error
                    </mat-icon>
                </mat-list-item>

                <mat-list-item role="listitem" mat-list-item (click)="logout()">
                    <mat-icon mat-list-icon color="warn">exit_to_app</mat-icon>
                    <h4 mat-line>Log Out</h4>
                </mat-list-item>
            </mat-nav-list>

        </mat-sidenav>
        <!-- <div [@splashAnimate]="splashScreen" class="splashscreenNav" fxLayout="column"
          fxFlex>
          <div fxFlex fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner></mat-spinner>
          </div>
      </div> -->
        <router-outlet>
            <ngx-spinner bdColor="rgba(0,0,0, 0.6)" size="medium"
                color="#66bb6a" type="ball-clip-rotate-multiple"
                [fullScreen]="true">
                <h3 style="color: black"> {{splashScreen.loadingMessage}} </h3>
            </ngx-spinner>
        </router-outlet>

    </mat-sidenav-container>
</div>